import { render, staticRenderFns } from "./TripActivities.vue?vue&type=template&id=b4bdad1e&"
import script from "./TripActivities.vue?vue&type=script&lang=js&"
export * from "./TripActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4bdad1e')) {
      api.createRecord('b4bdad1e', component.options)
    } else {
      api.reload('b4bdad1e', component.options)
    }
    module.hot.accept("./TripActivities.vue?vue&type=template&id=b4bdad1e&", function () {
      api.rerender('b4bdad1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/TripActivities.vue"
export default component.exports